import script from "./ColorWheelPiece.vue?vue&type=script&setup=true&lang=ts"
export * from "./ColorWheelPiece.vue?vue&type=script&setup=true&lang=ts"

import "./ColorWheelPiece.vue?vue&type=style&index=0&id=958225a0&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/deployJob/project/music-teach/h5-internal-examination/code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-958225a0"]])

export default __exports__